import React from 'react';
import classNames from 'classnames';

import css from './IconHouse.module.css';

/**
 * Map pin icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconHouse = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
 <svg
  className={classes}
  width="24"
  height="23"
  viewBox="0 0 24 23"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13.2122 0.502098C12.5427 -0.167366 11.4573 -0.167366 10.7878 0.502098L0.502102 10.7878C-0.167367 11.4573 -0.167367 12.5427 0.502102 13.2122C1.17157 13.8817 2.25699 13.8817 2.92647 13.2122L3.42857 12.7101V20.5714C3.42857 21.5182 4.19609 22.2857 5.14286 22.2857H18.8571C19.8039 22.2857 20.5714 21.5182 20.5714 20.5714V12.7101L21.0735 13.2122C21.743 13.8817 22.8285 13.8817 23.4979 13.2122C24.1673 12.5427 24.1673 11.4573 23.4979 10.7878L13.2122 0.502098Z"
    fill="#262338"
  />
  <defs>
    <clipPath id="clip0_2359_2730">
      <rect width="32" height="32" fill="white" />
    </clipPath>
  </defs>
</svg>
  );
};

export default IconHouse;
